<template>
    <div>
        <div :class="{'form-group mb-0': !tailwind, 'tw:mb-0': tailwind}">
            <select name="user-type" id="user-type"
                :class="{
                    'tw:mt-1 tw:block tw:w-full tw:rounded-lg tw:border tw:border-zinc-300 tw:bg-white tw:px-3 tw:py-2 tw:text-base tw:text-zinc-800 tw:focus:outline-none tw:focus:ring-1 tw:focus:ring-(--shop-primary) tw:focus:border-(--shop-primary)': tailwind,
                    'form-control': !tailwind
                }"
                v-model="wizardStore.user.type" autofocus="autofocus">
                <option :value="null">- {{ $t("Velg") }} -</option>
                <option :value="0">{{ isBookingSelfLabel }}</option>
                <option :value="2">{{ isBookingSomeoneElseLabel }}</option>
            </select>
        </div>

        <PrimaryButton
            :tailwind="wizardStore.tw"
            :onClick="validateAndContinue"
            :label="$t('Gå videre')" />
    </div>
</template>

<script setup>
    import { watch, computed } from "vue";
    import { STEP_USER_SELECT, useWizardStore } from './wizardState';
import PrimaryButton from "./primaryButton.vue";
    const wizardStore = useWizardStore();

    const tailwind = computed(() => wizardStore.tw);

    const isBookingSelfLabel = computed(() => {
        if (wizardStore.followUpId) {
            return window.TABS.$t("Jeg melder på meg selv")
        }
        if (wizardStore.courseId) {
            return window.TABS.$t("Jeg bestiller for meg selv (flere deltakere kan legges til senere)")
        }
        return window.TABS.$t("Jeg bestiller for meg selv")
    });

    const isBookingSomeoneElseLabel = computed(() => {
        if (wizardStore.followUpId) {
            return window.TABS.$t("Jeg melder på noen andre")
        }
        return window.TABS.$t("Jeg bestiller for noen andre")
    });

    watch(() => wizardStore.user.type, (newValue) => {
        wizardStore.resetFromStep(STEP_USER_SELECT);
        if (newValue === -1 || newValue === null) {
            return;
        }
        switch(newValue) {
            case 2: // booking for someone else
                wizardStore.contact.mobile = wizardStore.user.mobile;
                wizardStore.student.mobile = '';
                break;
            case 0: // self booking
            default:
                wizardStore.student.mobile = wizardStore.user.mobile;
                wizardStore.contact.mobile = '';
                break;
        }

        wizardStore.completeStep(STEP_USER_SELECT);
    });

    function validateAndContinue() {
        if (wizardStore.user.type === null || wizardStore.user.type === -1) {
            return;
        }
        wizardStore.completeStep(STEP_USER_SELECT);
    }
</script>
